import { createContext, useEffect, useState } from "react";
import { fetchDepartment } from "../services/coures/fetchDepartment";
import Alert from "../components/common/Alert";


export const DContext = createContext()

const DataContext = ({ children }) => {

    const BeURL = process.env.REACT_APP_BeURL
    const [isAuth, setIsAuth] = useState(null)
    const [currentUser, setCurrentUser] = useState(null)
    const [departmentList, setDepartmentList]=useState([])
    const [loading,setLoading]=useState(false)
    const [instructor,setInstructor]=useState(null)


    const [alert, setAlert] = useState(null);

    const showAlert = (message, type = "success") => {
        setAlert({ message, type });
    };


    useEffect(() => {
        fetch(`${BeURL}/checkauth`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setIsAuth(true);
                    setCurrentUser(data.user);
                } else {
                    setIsAuth(false);
                    setCurrentUser(null); 
                }
            })
            .catch(err => {
                setIsAuth(false);      
                setCurrentUser(null);
                console.log("Error in fetching User:", err);
            });
    }, [BeURL]);



    const handleLogout = () => {
        fetch(`${BeURL}/logout`, {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                showAlert(data.message)
                if (data.success) {
                    setIsAuth(false)
                    setCurrentUser({})
                    window.location.href = '/'
                }
            })
            .catch(err => {
                console.log("Erron in Logout:", err)
                showAlert("Trouble in connecting to the Server, please try again later.")
            })
    }


    useEffect(() => {
        const loadDepartments = async () => {

            const data = await fetchDepartment({ BeURL });

            if (data?.success) {
                setDepartmentList(data.departments);
            } else {
                showAlert(data.message);
            }

        };
        loadDepartments();
    }, [BeURL]);


    useEffect(() => {
        if (currentUser?.role === "instructor")
        fetch(`${BeURL}/fetch-instructor-profile`, {
            method: 'GET',
            credentials: 'include'
        })
            .then(res => res.json())
            .then(data => {
                if (data.success) {
                    setInstructor(data.Instructor);
                }
            })
            .catch(err => {
                console.error('Error in fetching instructor profile:', err);
            });
    },[BeURL , currentUser]);


    const Mandatory = () => (
        <span className="text-red-500">*</span>
    );


    const data = { isAuth, currentUser, setIsAuth, setCurrentUser, BeURL, handleLogout, departmentList, loading, setLoading, instructor, setInstructor, Mandatory, showAlert}

    return (
        <DContext.Provider value={data}>
            <Alert alert={alert} onClose={() => setAlert(null)} />
            {children}
        </DContext.Provider>
    )
}

export default DataContext